module.exports = __webpack_public_path__ + "static/randa-0187709d84f97253ddf61656ba675cb4.jpg";